import { camelize } from 'casing'
import { v4 as uuid4 } from 'uuid'
import { awsMarketplaceProductLink } from '../../../../common/utils/constants'
import type { BWAProduct, BWAProductGet } from '../../listingCardCreation/types'
import type { ButtonsData } from '../types'

export const transformDataFromGet = (data: Record<string, unknown>) => {
  const { product, id, template, name, type } = data
  const updatedProduct: BWAProduct[] =
    Object.keys(product as BWAProductGet).map((key: string) => {
      return {
        ...(product as BWAProductGet)[key],
        url: `${awsMarketplaceProductLink}/${key}`,
        isOpen: true,
        uniqueId: uuid4(),
        isLoading: false,
      }
    }) || []
  if (updatedProduct.length === 0) {
    updatedProduct.push({
      uniqueId: String(uuid4()),
      url: '',
      isOpen: true,
      isLoading: false,
    }) as unknown as BWAProduct[]
  }
  const upudatedButtonData = {
    buttonData: {
      ...camelize((template as any).data),
      name: name,
      type: type,
      id: (template as any).id,
    },
  }
  return {
    ...upudatedButtonData.buttonData,
    product: updatedProduct,
    integrationId: id,
  } as ButtonsData
}
